import React from 'react';
import { Combo } from 'fw/forms';

class TrueFalseFilter extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState();
    }

    initialState = () => {
        return {
            items: [
                { label: this.props.trueLabel, value: true },
                { label: this.props.falseLabel, value: false },
                { label: this.props.allLabel, value: null }
            ]
        }
    }

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                clearable={false}
                searchable={false} />
        )
    }
}

export default TrueFalseFilter;

// Mark this as a form component
TrueFalseFilter.defaultProps = {
	formControl: true,
	managed: false,
    trueLabel: "Yes",
    falseLabel: "No",
    allLabel: "All",
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/trueFalseFilter/TrueFalseFilter.js